import React from "react";
import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  MailOutlined,
  SnippetsOutlined,
  LineChartOutlined,
  GroupOutlined,
  ApartmentOutlined,
  AppstoreAddOutlined,
  DeliveredProcedureOutlined,
} from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars-2";
import styles from "./index.module.less";

function findPath(path, level) {
  let x = path.indexOf("/");
  for (let i = 0; i < level; i++) {
    x = path.indexOf("/", x + 1);
  }
  if (x < 0) return path;
  return path.substr(0, x);
}

function renderMenu(items, role = "user") {
  return items
    .filter((item) => item.roles.includes(role))
    .map((item) => {
      if (item.children) {
        const menus = renderMenu(item.children, role);
        return (
          <Menu.SubMenu key={item.url} icon={item.icon} title={item.label}>
            {menus}
          </Menu.SubMenu>
        );
      }
      return (
        <Menu.Item key={item.url} icon={item.icon}>
          <Link to={item.url}>{item.label}</Link>
        </Menu.Item>
      );
    });
}

const MENU_ITEMS = [
  {
    label: "信息处理",
    url: "/workshop/mproc",
    icon: <DeliveredProcedureOutlined />,
    roles: ["admin", "supervisor", "senioruser"],
    children: [
      {
        label: "新信息", //管理员：公告和新信息就是sendee为其部门的
        url: "/workshop/mproc/1",
        icon: "",
        roles: ["admin", "supervisor", "senioruser"],
      },
      {
        label: "待办事项",
        url: "/workshop/mproc/backlog",
        icon: "",
        roles: ["admin", "supervisor", "senioruser"],
      },
      {
        label: "未采用信息",
        url: "/workshop/mproc/other",
        icon: "",
        roles: ["admin", "supervisor", "senioruser"],
      },
      {
        label: "待处理信息",
        url: "/workshop/mproc/2",
        icon: "",
        roles: ["admin", "supervisor", "senioruser"],
      },
      {
        label: "已采用信息",
        url: "/workshop/mproc/4",
        icon: "",
        roles: ["admin", "supervisor", "senioruser"],
      },
      {
        label: "所有信息",
        url: "/workshop/mrece",
        icon: "",
        roles: ["admin", "supervisor"],
      },
    ],
  },
  {
    label: "公告查看",
    url: "/workshop/announce",
    icon: <SnippetsOutlined />,
    roles: ["admin", "supervisor", "senioruser", "user"],
    children: [
      {
        label: "公告",
        url: "/workshop/announce/0",
        icon: "",
        roles: ["admin", "supervisor", "senioruser", "user"],
      },
      {
        label: "成刊",
        url: "/workshop/announce/1",
        icon: "",
        roles: ["admin", "supervisor", "senioruser", "user"],
      },
      {
        label: "学习交流",
        url: "/workshop/announce/2",
        icon: "",
        roles: ["admin", "supervisor", "senioruser", "user"],
      },
      {
        label: "发布新公告",
        url: "/workshop/announce/form/new",
        icon: "",
        roles: ["admin", "supervisor", "senioruser"],
      },
      {
        label: "草稿箱",
        url: "/workshop/announce/draft",
        icon: "",
        roles: ["admin", "supervisor", "senioruser"],
      },
    ],
  },
  {
    label: "统计",
    url: "/workshop/statistic",
    icon: <LineChartOutlined />,
    roles: ["admin", "supervisor"],
    children: [
      {
        label: "信息统计",
        url: "/workshop/statistic/mess",
        icon: "",
        roles: ["admin", "supervisor"],
      },
      {
        label: "公告统计",
        url: "/workshop/statistic/anno",
        icon: "",
        roles: ["admin", "supervisor"],
      },
      {
        label: "报送情况",
        url: "/workshop/statistic/total",
        icon: "",
        roles: ["admin", "supervisor"],
      },
    ],
  },
  {
    label: "信息上报",
    url: "/workshop/msubm",
    icon: <MailOutlined />,
    roles: ["supervisor", "senioruser", "user"],
    children: [
      {
        label: "已上报信息",
        url: "/workshop/msubm/draft/finished",
        icon: "",
        roles: ["supervisor", "senioruser", "user"],
      },
      {
        label: "上报新信息",
        url: "/workshop/msubm/form/new",
        icon: "",
        roles: ["supervisor", "senioruser", "user"],
      },
      {
        label: "草稿箱",
        url: "/workshop/msubm/draft",
        icon: "",
        roles: ["supervisor", "senioruser", "user"],
      },
    ],
  },
  {
    label: "通讯录",
    url: "/workshop/addressbook",
    icon: <GroupOutlined />,
    roles: ["admin", "supervisor"],
  },
  {
    label: "单位管理",
    url: "/workshop/department",
    icon: <ApartmentOutlined />,
    roles: ["admin", "supervisor"],
  },
  {
    label: "系统设置",
    url: "/workshop/setting",
    icon: <AppstoreAddOutlined />,
    roles: ["admin", "supervisor"],
    children: [
      {
        label: "敏感词",
        url: "/workshop/setting/word",
        icon: "",
        roles: ["admin", "supervisor"],
      },
      {
        label: "信息类型",
        url: "/workshop/setting/mtype",
        icon: "",
        roles: ["admin", "supervisor"],
      },
      {
        label: "采用情况",
        url: "/workshop/setting/rtype",
        icon: "",
        roles: ["admin", "supervisor"],
      },
      {
        label: "刊物",
        url: "/workshop/setting/pub",
        icon: "",
        roles: ["admin", "supervisor"],
      },
      {
        label: "附加分",
        url: "/workshop/setting/apoint",
        icon: "",
        roles: ["admin", "supervisor"],
      },
      {
        label: "扣分项",
        url: "/workshop/setting/dpoint",
        icon: "",
        roles: ["admin", "supervisor"],
      },
    ],
  },
];

function Navigator() {
  const user = useSelector((state) => state.user.user);
  const { pathname } = useLocation();
  const level2Path = findPath(pathname, 2);
  return (
    <div className={styles.navigator}>
      <Scrollbars>
        <Menu
          theme="dark"
          mode="inline"
          defaultOpenKeys={[level2Path]}
          defaultSelectedKeys={[pathname]}
        >
          {renderMenu(MENU_ITEMS, user.roles)}
        </Menu>
      </Scrollbars>
    </div>
  );
}

export default Navigator;
